module.exports = __webpack_public_path__ + "img/123.f76fe05a.png";